import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  createClientProfile,
  getSerachClientProfile,
  getSerachUserProfile,
  updateClientProfile,
} from "../../services/ClientProfileServices";
import { Form } from "react-bootstrap";
import Select from "react-select";
import ConfigDB from "../../config";
import { getParentWarhouseData } from "../../services/PartsInventory";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  actionCityList,
  actionCountryList,
  actionStateList,
} from "../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../utils";

const AddResClient = ({
  reserveData,
  setStep,
  setReserveData,
  reserveDetails,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tableLengthList = ConfigDB.data.dataTableLength;

  const [clientResData, setClientResData] = useState({
    client_id: "",
    reservation_end_date: "",
    warehouses_id: "",
    users_id: [],
    shipping_price: "",
    packing_price: "",
    parcel_price: "",
    reservation_notes: "",
    send_email: 0,
    send_whatsapp: 0,
    reservation_end_alert: "",
    reservation_name: "",
  });
  const [entityList, setEntityList] = useState([]);

  let errorsObj = {
    client_id: "",
    users_id: "",
    reservation_name: "",
    reservation_end_alert: "",
    reservation_end_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    search: "",
    is_reload: false,
  });

  const [selectedEntities, setSelectedEntities] = useState({
    value: "",
    name: "",
  });

  const [clientDataList, setClientDataList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [modifyModal, setModifyModal] = useState(false);
  const [clientProfileData, setclientProfileData] = useState({
    uuid: "",
    id: "",
    name: "",
    district: "",
    city: "",
    bill_address: "",
    postal_code: "",
    shipping_addresses: [""],
    vat_country_code: "",
    vat_number: "",
    vat_percentage: 23,
    is_vat_exempt: "0",
    indicative_phone_code: "",
    phone_number: "",
    whatsapp_number: "",
    email: "",
    country_code: "",
    country_id: "",
  });

  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const handleAddModal = (item) => {
    setclientProfileData({
      uuid: item?.uuid,
      id: item?.id,
      name: item?.name,
      district: item?.district,
      city: item?.city,
      bill_address: item?.bill_address,
      postal_code: item?.postal_code,
      shipping_addresses: item?.shipping_addresses,
      vat_country_code: item?.vat_country_code,
      vat_number: item?.vat_number,
      vat_percentage: item?.vat_percentage,
      is_vat_exempt: item?.is_vat_exempt,
      indicative_phone_code: item?.indicative_phone_code,
      phone_number: item?.phone_number,
      whatsapp_number: item?.whatsapp_number,
      email: item?.email,
      country_code: item?.country_code,
      country_id: item?.country_id,
    });

    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);

    setclientProfileData({
      uuid: "",
      id: "",
      name: "",
      district: "",
      city: "",
      bill_address: "",
      postal_code: "",
      shipping_addresses: [""],
      vat_country_code: "",
      vat_number: "",
      vat_percentage: 23,
      is_vat_exempt: "0",
      indicative_phone_code: "",
      phone_number: "",
      whatsapp_number: "",
      email: "",
      country_code: "",
    });
  };

  const handleSaveDataModal = () => {
    setModifyModal(false);
  };

  const handleCheckboxChangeSendEmail = (e) => {
    setClientResData({
      ...clientResData,
      send_email: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeWhatsapp = (e) => {
    setClientResData({
      ...clientResData,
      send_whatsapp: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChange = (e) => {
    setclientProfileData({
      ...clientProfileData,
      is_vat_exempt: e.target.checked ? 1 : 0,
    });
  };

  const handleSelectChange = (event) => {
    const selectedIndex = event.target.selectedIndex;
    const selectedValue = event.target.value;
    const selectedName = event.target.options[selectedIndex].text;

    setSelectedEntities({ value: selectedValue, name: selectedName });
  };

  useEffect(function () {
    actionCountryList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setCountryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (clientProfileData?.country_id) {
      actionStateList({ country_id: clientProfileData?.country_id })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setStateList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  useEffect(() => {
    if (clientProfileData?.district) {
      actionCityList({ state_id: clientProfileData?.district })
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setCityList(list);
        })
        .catch((err) => {});
    }
  }, [clientProfileData]);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachClientProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setClientDataList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = { ...params };

    getParentWarhouseData(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.warehouse_name,
          });
        }
        setEntityList(list);
      })
      .catch((err) => {});
  }, []);

  const formatDateTimeLocal = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const offset = date.getTimezoneOffset() * 60000;
    const localISOTime = new Date(date.getTime() - offset)
      .toISOString()
      .slice(0, 16);

    return localISOTime;
  };

  useEffect(() => {
    if (reserveDetails) {
      setClientResData((prev) => ({
        ...prev,
        client_id: reserveDetails?.client_id,
        reservation_end_date: formatDateTimeLocal(
          reserveDetails?.reservation_end_date,
        ),
        warehouses_id: reserveDetails.warehouses_id,
        users_id: reserveDetails?.users_id,
        shipping_price: reserveDetails?.shipping_price,
        packing_price: reserveDetails?.packing_price,
        parcel_price: reserveDetails?.parcel_price,
        reservation_notes: reserveDetails?.reservation_notes,
        send_email: reserveDetails?.send_email,
        send_whatsapp: reserveDetails?.send_whatsapp,
        reservation_end_alert: formatDateTimeLocal(
          reserveDetails?.reservation_end_alert,
        ),
        reservation_name: reserveDetails?.reservation_name,
      }));
    }
  }, [reserveDetails]);

  useEffect(() => {
    if (reserveData) {
      setClientResData((prev) => ({
        ...prev,
        client_id: reserveData?.client_id,
        reservation_end_date: reserveData?.reservation_end_date,
        warehouses_id: reserveData.warehouses_id,
        users_id: reserveData?.users_id,
        shipping_price: reserveData?.shipping_price,
        packing_price: reserveData?.packing_price,
        parcel_price: reserveData?.parcel_price,
        reservation_notes: reserveData?.reservation_notes,
        send_email: reserveData?.send_email,
        send_whatsapp: reserveData?.send_whatsapp,
        reservation_end_alert: reserveData?.reservation_end_alert,
        reservation_name: reserveData?.reservation_name,
      }));
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    let data = {
      client_id: clientResData?.client_id,
      reservation_end_date: clientResData?.reservation_end_date,
      warehouses_id: clientResData?.warehouses_id,
      users_id: clientResData?.users_id,
      shipping_price: clientResData?.shipping_price,
      packing_price: clientResData?.packing_price,
      parcel_price: clientResData?.parcel_price,
      reservation_notes: clientResData?.reservation_notes,
      send_email: clientResData?.send_email,
      send_whatsapp: clientResData?.send_whatsapp,
      reservation_end_alert: clientResData?.reservation_end_alert,
      reservation_name: clientResData?.reservation_name,
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: clientProfileData?.vat_percentage,
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
    };

    setReserveData(data);
    setStep(2);
  };

  const handleAddressChange = (index, value) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses[index] = value;
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: [...clientProfileData.shipping_addresses, ""],
    });
  };

  const handleRemoveAddress = (index) => {
    const updatedAddresses = [...clientProfileData.shipping_addresses];
    updatedAddresses.splice(index, 1);
    setclientProfileData({
      ...clientProfileData,
      shipping_addresses: updatedAddresses,
    });
  };

  useEffect(() => {
    if (clientDataList && clientResData?.client_id) {
      const foundClient = clientDataList.find(
        (item) => item.value == clientResData.client_id,
      )?.fullData;
      setclientProfileData({
        uuid: foundClient?.uuid,
        id: foundClient?.id,
        name: foundClient?.name,
        district: foundClient?.district,
        city: foundClient?.city,
        bill_address: foundClient?.bill_address,
        postal_code: foundClient?.postal_code,
        shipping_addresses: foundClient?.shipping_addresses,
        vat_country_code: foundClient?.vat_country_code,
        vat_number: foundClient?.vat_number,
        vat_percentage: foundClient?.vat_percentage,
        is_vat_exempt: foundClient?.is_vat_exempt,
        indicative_phone_code: foundClient?.indicative_phone_code,
        phone_number: foundClient?.phone_number,
        whatsapp_number: foundClient?.whatsapp_number,
        email: foundClient?.email,
        country_code: foundClient?.country_code,
        country_id: foundClient?.country_id,
      });
    }
  }, [clientDataList, clientResData?.client_id]);

  useEffect(() => {
    if (reserveDetails) {
      setclientProfileData({
        uuid: "",
        id: "",
        name: reserveDetails?.client_name || "",

        district: reserveDetails?.client_district || "",
        city: reserveDetails?.client_city || "",
        bill_address: reserveDetails?.client_bill_address || "",
        postal_code: reserveDetails?.client_postal_code || "",
        shipping_addresses: Array.isArray(
          reserveDetails?.client_shipping_addresses,
        )
          ? reserveDetails.client_shipping_addresses
          : [],
        vat_country_code: reserveDetails?.client_vat_country_code || "",
        vat_number: reserveDetails?.client_vat_number || "",
        vat_percentage: reserveDetails?.client_vat_percentage || "",
        is_vat_exempt: reserveDetails?.client_is_vat_exempt || "0",
        indicative_phone_code:
          reserveDetails?.client_indicative_phone_code || "",
        phone_number: reserveDetails?.client_phone_number || "",
        whatsapp_number: reserveDetails?.client_phone_number || "",
        email: reserveDetails?.client_email || "",
        country_code: reserveDetails?.client_country_code || "",
      });
    }
  }, [reserveDetails]);

  const handleSubmitClient = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!clientProfileData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!clientProfileData.country_code) {
      errorObj.country_code = `Country is required.`;
      error = true;
    }

    if (!clientProfileData.district) {
      errorObj.district = `State is required.`;
      error = true;
    }

    if (!clientProfileData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!clientProfileData.bill_address) {
      errorObj.bill_address = `Bill address is required.`;
      error = true;
    }

    if (!clientProfileData.postal_code) {
      errorObj.postal_code = `Postal code is required.`;
      error = true;
    }

    if (!clientProfileData.email) {
      errorObj.email = `Email is required.`;
      error = true;
    }

    // if (!/^\d{3}$/.test(clientProfileData.indicative_phone_code)) {
    //   errorObj.indicative_phone_code = `Indicative phone code must be exactly 3 digits.`;
    //   error = true;
    // }

    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    setIsModifyButtonLoad(true);
    let data = {
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      country_id: clientProfileData?.country_id,
      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: clientProfileData?.vat_percentage,
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
    };

    let updateData = {
      uuid: clientProfileData?.uuid,
      name: clientProfileData?.name,
      country_code: clientProfileData?.country_code,
      country_id: clientProfileData?.country_id,

      district: clientProfileData?.district,
      city: clientProfileData?.city,
      bill_address: clientProfileData?.bill_address,
      postal_code: clientProfileData?.postal_code,
      shipping_addresses: clientProfileData?.shipping_addresses,
      vat_country_code: clientProfileData?.vat_country_code,
      vat_number: clientProfileData?.vat_number,
      vat_percentage: parseFloat(clientProfileData.vat_percentage),
      is_vat_exempt: clientProfileData?.is_vat_exempt,
      indicative_phone_code: clientProfileData?.indicative_phone_code,
      phone_number: clientProfileData?.phone_number,
      whatsapp_number: clientProfileData?.whatsapp_number,
      email: clientProfileData?.email,
    };

    if (clientProfileData?.uuid) {
      updateClientProfile(updateData)
        .then((response) => {
          toast.success(response.data.message);
          const obj = {
            search: "",
            limit: 20,
            page: 1,
          };
          getSerachClientProfile(obj)
            .then((response) => {
              response = response.data;
              let list = [];
              for (let i = 0; i < response.data.length; i++) {
                list.push({
                  value: response.data[i].id,
                  label: response.data[i].name,
                  fullData: response.data[i],
                });
              }

              setClientDataList(list);
            })
            .catch(() => {});
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setclientProfileData({
            uuid: "",
            id: "",
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
          setErrors({
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createClientProfile(data)
        .then((response) => {
          toast.success(response.data.message);
          const obj = {
            search: "",
            limit: 20,
            page: 1,
          };
          getSerachClientProfile(obj)
            .then((response) => {
              response = response.data;
              let list = [];
              for (let i = 0; i < response.data.length; i++) {
                list.push({
                  value: response.data[i].id,
                  label: response.data[i].name,
                  fullData: response.data[i],
                });
              }

              setClientDataList(list);
            })
            .catch(() => {});
          setModifyModal(false);
          setIsModifyButtonLoad(false);

          setclientProfileData({
            uuid: "",
            id: "",
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
          setErrors({
            name: "",
            country_id: "",
            country_code: "",
            district: "",
            city: "",
            bill_address: "",
            postal_code: "",
            shipping_addresses: [""],
            vat_country_code: "",
            vat_number: "",
            vat_percentage: "",
            is_vat_exempt: "",
            indicative_phone_code: "",
            phone_number: "",
            whatsapp_number: "",
            email: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content">
          <div className="container-fluidcontainer-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="">
                    <div className="">
                      <div className="card-header">
                        <div className="card-title m-0 float-left d-flex">
                          <button
                            type="button"
                            className="btn btn-block btn-primary"
                            onClick={() => navigate("/show-reserves-list")}
                            style={{ width: "100px", marginTop: "10px" }}
                          >{t("back")}<i className="bi bi-arrow-left-short"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <Form method={`post`}>
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("reservation_name")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="text"
                                  className="form-control input-search"
                                  value={clientResData.reservation_name}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      reservation_name: e.target.value,
                                    });
                                  }}
                                  name="reservation_name"
                                  placeholder={t("reservation_name")}
                                />
                                {errors.reservation_name && (
                                  <span className="input-error">
                                    {errors.reservation_name}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label position-relative w-100">
                              Select Client
                              <span
                                className="info-icon-right-new"
                                onClick={() => {
                                  const selectedClient = clientDataList.find(
                                    (item) =>
                                      item.value == clientResData.client_id,
                                  )?.fullData;

                                  if (selectedClient) {
                                    handleAddModal(selectedClient);
                                  } else {
                                    const fallbackData = {
                                      uuid: "",
                                      id: "",
                                      name: reserveDetails?.client_name || "",

                                      district:
                                        reserveDetails?.client_district || "",
                                      city: reserveDetails?.client_city || "",
                                      bill_address:
                                        reserveDetails?.client_bill_address ||
                                        "",
                                      postal_code:
                                        reserveDetails?.client_postal_code ||
                                        "",
                                      shipping_addresses: Array.isArray(
                                        reserveDetails?.client_shipping_addresses,
                                      )
                                        ? reserveDetails.client_shipping_addresses
                                        : [],
                                      vat_country_code:
                                        reserveDetails?.client_vat_country_code ||
                                        "",
                                      vat_number:
                                        reserveDetails?.client_vat_number || "",
                                      vat_percentage:
                                        reserveDetails?.client_vat_percentage ||
                                        "",
                                      is_vat_exempt:
                                        reserveDetails?.client_is_vat_exempt ||
                                        "0",
                                      indicative_phone_code:
                                        reserveDetails?.client_indicative_phone_code ||
                                        "",
                                      phone_number:
                                        reserveDetails?.client_phone_number ||
                                        "",
                                      whatsapp_number:
                                        reserveDetails?.client_phone_number ||
                                        "",
                                      email: reserveDetails?.client_email || "",
                                      country_code:
                                        reserveDetails?.client_country_code ||
                                        "",
                                    };

                                    setclientProfileData(fallbackData);
                                    handleAddModal(fallbackData);
                                  }
                                }}
                              >
                                <i className="bi bi-info-circle-fill"></i>
                              </span>
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={clientDataList}
                                  value={clientDataList.find(
                                    (item) =>
                                      item.value == clientResData.client_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setClientResData({
                                      ...clientResData,
                                      client_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Client"}
                                />

                                {errors.client_id && (
                                  <span className="input-error">
                                    {errors.client_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              Reservation end date
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="datetime-local"
                                  className="form-control input-search"
                                  value={clientResData.reservation_end_date}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      reservation_end_date: e.target.value,
                                    });
                                  }}
                                  name="reservation_end_date"
                                  placeholder={t("reservation_end_date")}
                                />
                                {errors.reservation_end_date && (
                                  <span className="input-error">
                                    {errors.reservation_end_date}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              Select User
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={userDataList}
                                  value={userDataList.filter((item) =>
                                    clientResData.users_id?.includes(
                                      item.value,
                                    ),
                                  )}
                                  onChange={(selectedOptions) => {
                                    setClientResData({
                                      ...clientResData,
                                      users_id: selectedOptions
                                        ? selectedOptions.map(
                                            (opt) => opt.value,
                                          )
                                        : [],
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  isMulti={true}
                                  placeholder={"Select Users"}
                                />
                                {errors.users_id && (
                                  <span className="input-error">
                                    {errors.users_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              Warehouse
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={entityList}
                                  value={entityList.find(
                                    (item) =>
                                      item.value == clientResData.warehouses_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setClientResData({
                                      ...clientResData,
                                      warehouses_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Warehouse"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              Shipping Price
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="number"
                                  className="form-control input-search"
                                  value={clientResData.shipping_price}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      shipping_price: e.target.value,
                                    });
                                  }}
                                  name="shipping_price"
                                  placeholder={t("shipping_price")}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("packing_price")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="number"
                                  className="form-control input-search"
                                  value={clientResData.packing_price}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      packing_price: e.target.value,
                                    });
                                  }}
                                  name="packing_price"
                                  placeholder={t("packing_price")}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("parcel_price")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="number"
                                  className="form-control input-search"
                                  value={clientResData.parcel_price}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      parcel_price: e.target.value,
                                    });
                                  }}
                                  name="parcel_price"
                                  placeholder={t("parcel_price")}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label">
                              {t("send_email")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div mt-12">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={clientResData.send_email}
                                    onChange={handleCheckboxChangeSendEmail}
                                  />
                                  <label className="form-check-label pl-6">
                                    {t("send_email")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label">
                              {t("send_whatsapp")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div mt-12">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={clientResData.send_whatsapp}
                                    onChange={handleCheckboxChangeWhatsapp}
                                  />
                                  <label className="form-check-label pl-6">
                                    {t("send_whatsapp")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              Reservation end date alert
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  type="datetime-local"
                                  className="form-control input-search"
                                  value={clientResData.reservation_end_alert}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      reservation_end_alert: e.target.value,
                                    });
                                  }}
                                  name="reservation_end_alert"
                                  placeholder={t("reservation_end_date_alert")}
                                />
                                {errors.reservation_end_alert && (
                                  <span className="input-error">
                                    {errors.reservation_end_alert}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-12">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("reservation_notes")}{" "}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  type="text"
                                  className="form-control input-search"
                                  value={clientResData.reservation_notes}
                                  onChange={(e) => {
                                    setClientResData({
                                      ...clientResData,
                                      reservation_notes: e.target.value,
                                    });
                                  }}
                                  name="reservation_notes"
                                  rows={3}
                                  placeholder={t("reservation_notes")}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>

            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleSubmit}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("next")}<i className="bi bi-x-lg"></i>
            </button>
          </div>
        </section>
      </div>

      <Modal isOpen={modifyModal} size="lg">
        <ModalHeader>{t("client_profile")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitClient}>
          <ModalBody>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.name}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder={t("name")}
                      />
                      {errors.name && (
                        <span className="input-error">{errors.name}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            country_code: e.target.value,
                          });
                        }}
                        name={`country_code`}
                        maxLength={50}
                        placeholder={t("country_code")}
                      />
                      {errors.country_code && (
                        <span className="input-error">
                          {errors.country_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={countryList}
                        value={countryList.find(
                          (option) =>
                            option.value ===
                            Number(clientProfileData.country_id),
                        )}
                        onChange={(selectedOption) => {
                          const selectedCountryId = selectedOption
                            ? selectedOption.value
                            : "";

                          setclientProfileData({
                            ...clientProfileData,
                            country_id: selectedCountryId,
                            district: "",
                            city: "",
                          });

                          if (!selectedOption) {
                            setStateList([]);
                            setCityList([]);
                          }
                        }}
                        isClearable
                        isSearchable
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("state")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={stateList}
                        value={stateList.find(
                          (option) =>
                            option.value === Number(clientProfileData.district),
                        )}
                        onChange={(selectedOption) => {
                          const selectedStateId = selectedOption
                            ? selectedOption.value
                            : "";

                          setclientProfileData({
                            ...clientProfileData,
                            district: selectedStateId,
                            city: "",
                          });

                          if (!selectedOption) {
                            setCityList([]);
                          }
                        }}
                        isDisabled={!clientProfileData.country_id}
                        isClearable
                        isSearchable
                      />
                      {errors.district && (
                        <span className="input-error">{errors.district}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={cityList}
                        value={cityList.find(
                          (option) =>
                            option.value === Number(clientProfileData.city),
                        )}
                        onChange={(selectedOption) => {
                          setclientProfileData({
                            ...clientProfileData,
                            city: selectedOption.value
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isDisabled={!clientProfileData.district}
                        isClearable
                        isSearchable
                      />
                      {errors.city && (
                        <span className="input-error">{errors.city}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("bill_address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.bill_address}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            bill_address: e.target.value,
                          });
                        }}
                        name={`bill_address`}
                        maxLength={50}
                        placeholder={t("bill_address")}
                      />

                      {errors.bill_address && (
                        <span className="input-error">
                          {errors.bill_address}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("postal_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.postal_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            postal_code: e.target.value,
                          });
                        }}
                        name={`postal_code`}
                        maxLength={50}
                        placeholder={t("postal_code")}
                      />

                      {errors.postal_code && (
                        <span className="input-error">
                          {errors.postal_code}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_country_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_country_code}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_country_code: e.target.value,
                          });
                        }}
                        name={`vat_country_code`}
                        maxLength={50}
                        placeholder={t("vat_country_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_number: e.target.value,
                          });
                        }}
                        name={`vat_number`}
                        maxLength={50}
                        placeholder={t("vat_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("vat_percentages")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.vat_percentage ?? 23}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            vat_percentage: e.target.value,
                          });
                        }}
                        name="vat_percentage"
                        maxLength={50}
                        placeholder={t("vat_percentages")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("is_VAT_exempt")}{" "}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={clientProfileData?.is_vat_exempt === 1}
                          onChange={handleCheckboxChange}
                        />
                        <label className="form-check-label pl-2">
                          VAT exempt{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("indicative_phone_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={
                          clientProfileData.indicative_phone_code || "+351"
                        }
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            indicative_phone_code: e.target.value,
                          });
                        }}
                        name={`indicative_phone_code`}
                        maxLength={50}
                        placeholder={t("indicative_phone_code")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.phone_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            phone_number: e.target.value,
                          });
                        }}
                        name={`phone_number`}
                        maxLength={50}
                        placeholder={t("phone_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("whatsapp_number")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.whatsapp_number}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            whatsapp_number: e.target.value,
                          });
                        }}
                        name={`whatsapp_number`}
                        maxLength={50}
                        placeholder={t("whatsapp_number")}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={clientProfileData.email}
                        onChange={(e) => {
                          setclientProfileData({
                            ...clientProfileData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder={t("email")}
                      />
                      {errors.email && (
                        <span className="input-error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4"></div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("shipping_address")}
                  </Label>
                  <div className="col-xl-12">
                    {clientProfileData?.shipping_addresses?.map(
                      (address, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-2"
                        >
                          <input
                            type="text"
                            className="form-control input-search mr-2"
                            placeholder={`Shipping address ${index + 1}`}
                            value={address}
                            onChange={(e) =>
                              handleAddressChange(index, e.target.value)
                            } // Update address
                          />
                          <i
                            className="bi bi-x-circle"
                            style={{
                              marginTop: "-41px",
                              marginLeft: "-16px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveAddress(index)} // Remove address
                          ></i>
                        </div>
                      ),
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={handleAddAddress} // Add address
                    >
                      ➕ {t("add_address")}
                    </button>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddResClient;
